export default "__VITE_ASSET__7ff61a45__"